// extracted by mini-css-extract-plugin
export default {"tableLoaderContainer":"WhiteCard_tableLoaderContainer__8nyLH","tableContainer":"WhiteCard_tableContainer__m01ms"};